import React from 'react';
import { Flex, message } from 'antd';
import {
  CustomModalWithoutButton,
  CustomButton,
  CustomParagraph,
} from '../../../components';
import { ArchiveShipment } from '../../../apis/shipment';

interface ArchiveShipmentModalProps {
  deleteShipmentModalOpen: boolean;
  setDeleteShipmentModalOpen: (open: boolean) => void;
  shipmentId: string;
  closeDeleteModal: () => void;
  checkTokenExpiry: () => string;
  unauthorize: (error: unknown) => void;
}

const ArchiveShipmentModal: React.FC<ArchiveShipmentModalProps> = ({
  deleteShipmentModalOpen,
  setDeleteShipmentModalOpen,
  shipmentId,
  closeDeleteModal,
  checkTokenExpiry,
  unauthorize,
}) => {
  const handleDeleteShipmentModal = (): void => {
    const model = { shipment_id: shipmentId };
    const token = checkTokenExpiry();
    // The original JSX code was passing 'model' here, which is almost certainly
    // wrong. TODO: probably just pass shipmentId directly?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ArchiveShipment(model as any, token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            closeDeleteModal();
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((err) => {
        unauthorize(err);
      });
  };

  return (
    <>
      <CustomModalWithoutButton
        modalOpen={deleteShipmentModalOpen}
        setModalOpen={setDeleteShipmentModalOpen}
        modalTitle='Archive Shipment'
        modalText=''
        modalSize={524}
        fontSize={'24px'}
        lineHeight='32px'
      >
        <Flex vertical={true} gap={20}>
          <CustomParagraph
            text='Stop tracking this shipment on Zoomlogi.'
            marginTop={'8px'}
            marginBottom={'4px'}
          />

          <Flex gap='16px' justify='end'>
            <CustomButton
              text={'Cancel'}
              bgColor='transparent'
              color='black'
              fontSize='16px'
              fontWeight='500'
              boxShadow='none'
              height='32px'
              onClick={() => setDeleteShipmentModalOpen(false)}
            />
            <CustomButton
              text={'Archive Shipment'}
              bgColor='var(--danger)'
              color='white'
              width='154px'
              fontSize='16px'
              fontWeight='500'
              boxShadow='none'
              borderRadius='8px'
              htmlType='submit'
              onClick={() => handleDeleteShipmentModal()}
            />
          </Flex>
        </Flex>
      </CustomModalWithoutButton>
    </>
  );
};

export default ArchiveShipmentModal;
